import { COLORS, SIZES, SPACING, TYPOGRAPHY } from '@alto/design-library-tokens';
import { Body, Card, H3, LgPadding, XsSpacing, useScreenSize } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';
import styledNative from 'styled-components/native';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';
import expeditedDelivery from '~web/images/deliveryNoBackground.png';
import lowPrice from '~web/images/priceInvestigate@3x.png';
import chatPharmacist from '~web/images/secureMessagingNoBackground.png';

const Div = styled.div<{ isMDScreenOrBigger: boolean }>`
  display: none;
  z-index: 0;

  ${({ isMDScreenOrBigger }) => isMDScreenOrBigger && `display: initial;`}
`;

const CustomCard = styledNative(Card)`
  margin: 0 0 ${SPACING.STATIC.XL.px};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;
const CardTextContainer = styled.div`
  margin-left: ${SPACING.STATIC.MD.px};
  * {
    color: ${COLORS.TEXT_COLORS.PRIMARY};
  }
  h3 {
    font-size: ${TYPOGRAPHY.TEXT.HEADER.SM.px};
  }
`;
const FeaturesContainer = styled.div`
  display: flex;
`;
const Feature = styled.div`
  padding: ${SPACING.STATIC.MD.px};
  display: flex;
  align-items: center;
  flex-basis: 33.33%;
  position: relative;
  &:not(:first-child) {
    &::before {
      position: absolute;
      content: '';
      border-left: 1px solid ${COLORS.PALETTE.GREYSCALE.DEFAULT};
      height: ${SIZES.ILLUSTRATION.SM.px};
      left: 0;
      top: calc(50% - ${SIZES.ILLUSTRATION.SM.value / 2}px);
    }
  }
`;
const Illustration = styled.img<{ width?: string }>`
  width: ${({ width }) => width || SIZES.ILLUSTRATION.MD.px};
  margin-right: ${SPACING.STATIC.XS.px};
`;

export default function NoNewUpdates() {
  const { isMDScreenOrBigger } = useScreenSize();
  return (
    <Div isMDScreenOrBigger={isMDScreenOrBigger}>
      <CustomCard>
        <LgPadding>
          <Illustration
            src={getImage('pillBottle')}
            width="120px"
            alt={IMG_ALT_TEXTS.pillBottle}
          />
          <CardTextContainer>
            <H3>No new updates</H3>
            <XsSpacing />
            <Body>Any new scheduled deliveries, new medications, and refill requests will show up here.</Body>
          </CardTextContainer>
        </LgPadding>
      </CustomCard>
      <FeaturesContainer>
        <Feature>
          <Illustration src={lowPrice} />
          <Body color={COLORS.TEXT_COLORS.PRIMARY}>Low prices</Body>
        </Feature>
        <Feature>
          <Illustration src={expeditedDelivery} />
          <Body color={COLORS.TEXT_COLORS.PRIMARY}>Delivery to your door</Body>
        </Feature>
        <Feature>
          <Illustration src={chatPharmacist} />
          <Body color={COLORS.TEXT_COLORS.PRIMARY}>Chat with a pharmacist</Body>
        </Feature>
      </FeaturesContainer>
    </Div>
  );
}
